export default __webpack_public_path__ + "static/media/CrossIcon.440ba137.svg";